let mapper_options = {
  endpoint: 'templates',
  recordClass: require('./record'),
  relations: {
    hasOne: {
      landing_page: {
        localKey: 'landing_page_id',
        localField: 'landing_page'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('template', mapper_options)
}
